import { ArrowDown01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react-native';
import React, { useState, type ReactNode } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { Colors } from '../constants/Colors';
import { TextReg } from './StyledText';

type Props = {
  title: string;
  children: ReactNode;
  initialExpanded?: boolean;
};

export function CollapsibleSection({
  title,
  children,
  initialExpanded = false,
}: Props) {
  const [isExpanded, setIsExpanded] = useState(initialExpanded);

  return (
    <View style={styles.container}>
      <Pressable
        style={styles.header}
        onPress={() => setIsExpanded(!isExpanded)}
      >
        <View
          style={[
            styles.chevronContainer,
            isExpanded && styles.chevronExpanded,
          ]}
        >
          <HugeiconsIcon icon={ArrowDown01Icon} size={20} color={Colors.text} />
        </View>
        <TextReg style={styles.title}>{title}</TextReg>
      </Pressable>

      {isExpanded && <View style={styles.content}>{children}</View>}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.opacity05,
    borderRadius: 16,
    overflow: 'hidden',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    gap: 8,
  },
  chevronContainer: {
    transform: [{ rotate: '-90deg' }],
  },
  chevronExpanded: {
    transform: [{ rotate: '0deg' }],
  },
  title: {
    flex: 1,
  },
  content: {
    paddingHorizontal: 16,
    paddingBottom: 16,
    gap: 24,
  },
});
